// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartComponent_button__K0DTU","icon":"HeaderCartComponent_icon__tWt45","badge":"HeaderCartComponent_badge__Wz7R9","bump":"HeaderCartComponent_bump__964WV"};